import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import MembersComponent from '../components/MembersComponent'

const mapStateToProps = (state) => {
  return {
    members: state.members,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembersComponent)
